import { useSelector } from 'react-redux';
import {
  selectDefaultPaymentMethod,
  selectFailedSubscriptions,
  selectPlanList,
  subscriptionActions,
} from '../../redux/slicers/subscriptionSlicer';
import { RECURRING_INTERVAL, calculatePlanPrice, convertStripeCentsToAmount } from './subscriptionHelper';
import ActionLink from './ActionLink';
import { MessageBar } from './MessageBar';
import {
  apiCancelAllInvoices,
  apiMakeSubscriptionPendingPayment,
  getDowngradeInvoiceDetails,
  setClientSubscriptionPlans,
  setFailedClientSubscriptionPlansAndAddOns,
} from '../../api/subscription/subscription';
import { getCurrentUserOrganization } from '../../contexts/UserContext';
import { errorToast, infoToast, successToast, warningToast } from '../../helpers/toastHelper';
import { dispatcher, navigate } from '../../helpers/projectHelper';
import { useEffect, useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { wait } from '../../helpers/jsHelper';
import { SETTINGS_ROUTE } from '../../constants/routePathConstants';
import { SETTINGS_TAB } from '../../constants/constants';
import { getAppState } from '../../redux/store';
import { LogConsole } from '../../helpers/logEvents';

export const handlePendingPayment = async ({
  id = null,
  name = '',
  pending_pi_client_secret_key = null,
  callback = () => {},
  stripe,
}) => {
  if (!id) return;

  // await apiMakeSubscriptionPendingPayment({
  //   id: id,
  //   organization: getCurrentUserOrganization(),
  // }).then(async (response) => {
  const defaultPaymentMethod = selectDefaultPaymentMethod(getAppState());
  const savedDefaultPM = defaultPaymentMethod?.stripe_payment_method_id;

  if (!savedDefaultPM) {
    errorToast('Please add your payment method.');
    callback?.(id);
    return;
  }

  const paymentIntentClientSecret = pending_pi_client_secret_key; // response?.pending_pi_client_secret_key;
  if (paymentIntentClientSecret) {
    await stripe
      .confirmPayment({
        clientSecret: paymentIntentClientSecret,
        confirmParams: {
          payment_method: savedDefaultPM,
          return_url: window.location.href,
        },
        redirect: 'if_required',
      })
      .then(async (response) => {
        const { status, error, paymentIntent } = response;

        LogConsole('pending payment', { error, paymentIntent, response });

        const isSucceeded = status === 'succeeded' || paymentIntent?.status === 'succeeded';
        const isProcessing = status === 'processing' || paymentIntent?.status === 'processing';

        await wait(3000);

        // debugger
        if (error) {
          if (error.param === 'mandate_data' && error.payment_intent.status === 'processing') {
            infoToast('Your payment is currently being processed.');
            dispatcher(setClientSubscriptionPlans());
          } else if (error?.payment_intent?.status === 'requires_payment_method') {
            errorToast(error?.message || 'Please add payment method.');
          } else if (error?.payment_intent?.status === 'canceled') {
            // dispatcher(setFailedClientSubscriptionPlansAndAddOns());
            // dispatcher(setClientSubscriptionPlans());
            await dispatcher(setFailedClientSubscriptionPlansAndAddOns());
            errorToast('Your payment is cancelled.');
          } else {
            if (error?.payment_intent?.status === 'processing') {
              infoToast('Your payment is currently under processing.');
              dispatcher(setClientSubscriptionPlans());
            } else {
              errorToast(error?.message || 'Something went wrong. Please try again later.');
            }
          }
          dispatcher(setFailedClientSubscriptionPlansAndAddOns());
          dispatcher(setClientSubscriptionPlans());
        } else {
          await wait(1000);
          dispatcher(setFailedClientSubscriptionPlansAndAddOns());
          dispatcher(setClientSubscriptionPlans());
          if (isSucceeded) {
            successToast(`Your payment has been successfully${name ? ` made for ${name}.` : '.'}`);
          } else if (isProcessing) {
            infoToast('Your payment is currently under processing.');
          }
        }
      });

    callback?.(id);
  } else {
    dispatcher(setFailedClientSubscriptionPlansAndAddOns());
    dispatcher(setClientSubscriptionPlans());
    errorToast('Invalid payment client secret key.');
    callback?.(id);
  }
  // if(response && response?.id && !paymentIntentClientSecret) {
  //   dispatcher(setFailedClientSubscriptionPlansAndAddOns());
  //   dispatcher(setClientSubscriptionPlans());
  //   await wait(3000);
  //   successToast(`Your payment has been successfully${name ? ` made for ${name}.` : '.'}`);
  // }
  // })
  // .catch((error) => {
  //   if(error?.message?.toLowerCase()?.includes('please add your payment method')) {
  //     errorToast(error.message);
  //     navigate(`${SETTINGS_ROUTE}?activeTab=${SETTINGS_TAB.BILLING}`);
  //     // dispatcher(subscriptionActions.setShowCardForm(true));
  //   } else if (error?.message?.toLowerCase()?.includes('it has a status of processing')) {
  //     dispatcher(setFailedClientSubscriptionPlansAndAddOns());
  //     dispatcher(setClientSubscriptionPlans());
  //     infoToast('Your payment is currently being processed.');
  //   } else {
  //     errorToast(error.message || 'Unable to make pending payment. Please try again later.');
  //   }
  // })
  // .finally(() => callback?.(id));
};

export const FailedSubscriptions = () => {
  const failedSubscriptions = useSelector(selectFailedSubscriptions);
  const plans = selectPlanList(getAppState());
  const [loadingIds, setLoadingIds] = useState([]);
  const stripe = useStripe();

  const [messages, setMessages] = useState([]);

  // const calculateAmount = (value) => {
  //   if (value && value?.length) {
  //     let sum = 0;
  //     value.map((list) => {
  //       sum = sum + +list?.price_amount * +list?.product_quantity;
  //     });
  //     return convertStripeCentsToAmount(+sum);
  //   } else {
  //     return 0;
  //   }
  // };

  const checkIfLoading = (id) => loadingIds.includes(id);

  const handleLoading = (id) => {
    let ids = [...loadingIds];
    if (ids.includes(id)) {
      ids = [...ids.filter((a) => a !== id)];
    } else {
      ids.push(id);
    }
    setLoadingIds(ids);
  };
  const callback = (id) => setLoadingIds((prev) => prev.filter((a) => a !== id));

  const handlePayment = ({ id, name, pending_pi_client_secret_key }) => {
    if (checkIfLoading(id)) {
      warningToast('Please wait. Your payment is being processed.');
      return;
    }
    handleLoading(id);
    handlePendingPayment({ id, name, pending_pi_client_secret_key, callback, stripe });
  };

  const cancelPayments = async ({ id, payments }) => {
    const data = await apiCancelAllInvoices({ payments });
    const failedPayment = data.find((_item) => !_item || !_item?.is_success);
    if (!failedPayment) {
      successToast('Your payment has been cancelled successfully.');
    }
    await dispatcher(setFailedClientSubscriptionPlansAndAddOns());
    callback(id);
  };

  const handleCancelPayment = ({ id, payment, setupIntentId }) => {
    if (checkIfLoading(id)) {
      warningToast('Please wait. Cancelling you pending payment');
      return;
    }
    handleLoading(id);
    if (setupIntentId) {
      const payments = failedSubscriptions?.filter(
        (_item) => _item?.quote_details?.setupintent_id === setupIntentId
      );
      cancelPayments({ id, payments });
    } else cancelPayments({ id, payments: [payment] });
  };

  const redirectToCheckoutPage = (setup_intent) => {
    const checkoutPageUrl = `${process.env.REACT_APP_CHECKOUT_PAGE_URL}?setup_intent=${setup_intent}`;
    dispatcher(
      subscriptionActions.setFailedSubscriptions(
        failedSubscriptions?.filter(
          (_item) => _item?.quote_details?.setupintent_id !== setup_intent
        ) || []
      )
    );
    window.open(checkoutPageUrl, '_blank');
  };

  const getText = async (s = {}) => {
    if (s?.is_cancelled === true || s?.status === 'deleted') return null;
    const id = s?.id;
    let amount = '';
    let name = '';
    let plan = s?.plan_details;
    const downgradePlanId = s?.downgraded_plan_id;
    const setupIntentId = s?.quote_details?.setupintent_id;
    const quoteName = s?.quote_details?.title || s?.quote_details?.hs_quote_id;
    const isUploadLimitPlan = s?.is_upload_limit_plan

    // this is for the self serve plan
    const plans = selectPlanList(getAppState());
    if(!plans?.length && downgradePlanId){
      return null
    }
    const uploadPlan = isUploadLimitPlan && downgradePlanId && plans?.filter(({id})=> +id === +s?.plan_details?.[0]?.plan_id) || []
    const downgradePlanPriceDetails = downgradePlanId && uploadPlan
  ?.find(({ pricing_details }) => pricing_details?.some(({ stripe_price_id }) => stripe_price_id === downgradePlanId))
  ?.pricing_details?.find(({ stripe_price_id }) => stripe_price_id === downgradePlanId);

    const isModifiedPlan = s?.main_plan_modify || s?.is_upload_limit_plan_modification; 
    const modifiedPlanName = plans?.find(
      (a) => a.pricing_details?.findIndex((b) => b.stripe_price_id === s?.main_plan_modify_price_id) !== -1
    )?.name;

    LogConsole('DEBUG___getText', { s, plan, plans, modifiedPlanName });

    if (!setupIntentId) {
      if (!s?.is_add_on_subscription && !s?.is_upload_limit_plan) {
        name = isModifiedPlan
          ? modifiedPlanName
          : plan.length > 0
          ? plan?.[0]?.plan_name + ' Plan'
          : s?.plan_name
          ? s?.plan_name + ' Plan'
          : '';
        amount = plan.length > 0 ? convertStripeCentsToAmount(plan?.[0]?.price_amount) : '';

        if ((!name || downgradePlanId) && s?.incomplete_invoice_id) {
          await getDowngradeInvoiceDetails(s?.incomplete_invoice_id)
            .then((response) => {
              if (response) {
                name = response?.name?.[0] ? `${response?.name?.[0]} plan` : '';
                amount = response?.amount_due;
              }
            })
            .catch((error) => {
              LogConsole('getText error', error);
            });
        }
        if (downgradePlanPriceDetails) {
          amount = convertStripeCentsToAmount(downgradePlanPriceDetails?.unit_amount) || amount;
        }
      } else if (s?.is_add_on_subscription && !s?.is_upload_limit_plan) {
        const isAllMonthly =
          plan.length > 0
            ? plan.every((a) => +a.recurring_interval_id === RECURRING_INTERVAL.MONTH)
            : +s?.recurring_interval === RECURRING_INTERVAL.MONTH;
        const isAllYearly =
          plan.length > 0
            ? plan.every((a) => +a.recurring_interval_id === RECURRING_INTERVAL.YEAR)
            : +s?.recurring_interval === RECURRING_INTERVAL.YEAR;

        if (isAllMonthly) {
          name = 'Monthly Add-ons';
          // amount = calculateAmount(plan);
        } else if (isAllYearly) {
          name = 'Yearly Add-ons';
          // amount = calculateAmount(plan);
        }
      } else if (s?.is_upload_limit_plan) {
        // name = plan.length > 0 ? plan?.[0]?.plan_name?.replace("Plan", "") + ' Plan' : s?.plan_name;
        // amount = plan.length > 0 ? convertStripeCentsToAmount(plan?.[0]?.price_amount) : '';

        name = 'Creator plan';

        if(s?.is_request) { // showing the plan name if the plan purchase from the new request view
          name = plan?.[0]?.plan_name;
        }

        amount = calculatePlanPrice({ plan: s });

        // In case of the US bank, we don't get the plan details in the subscription 
        // that's why we have the 0 amount we don't need to show it to the user in the UI
        if (amount === 0 && !s?.incomplete_invoice_id) {
          amount = '';
        }
        if (s?.incomplete_invoice_id) {
          await getDowngradeInvoiceDetails(s?.incomplete_invoice_id)
            .then((response) => {
              if (response) {
                amount = response?.amount_due || "";
              }
            })
            .catch((error) => {
              LogConsole('getText error', error);
            });
        }
        // if (!name) {
        //   await getDowngradeInvoiceDetails(s?.incomplete_invoice_id)
        //     .then((response) => {
        //       if (response) {
        //         name = response?.name?.[0]
        //           ? `${response?.name?.[0]?.replace('Plan', '')} Plan`
        //           : '';
        //       }
        //     })
        //     .catch((error) => {
        //       name =
        //         plan.length > 0
        //           ? plan?.[0]?.plan_name?.replace('Plan', '') + ' Plan'
        //           : s?.plan_name || 'Upload Limit Plan';
        //       LogConsole('getText error', error);
        //     });
        // }
        // if (downgradePlanPriceDetails) {
        //   amount = convertStripeCentsToAmount(downgradePlanPriceDetails?.unit_amount) || amount;
        // }
      }
      if (!name) return null;
    }
    if (name) {
      name = name?.toLocaleLowerCase()?.replace('plan plan', 'plan');
    }

    const finalMsg =
      amount !== '' && !isModifiedPlan ? (
        <>
          Payment of&nbsp;<strong>${amount} USD</strong>&nbsp;for the&nbsp;
          <strong className="text-capitalize">{name}</strong>
          &nbsp;is pending!
        </>
      ) : setupIntentId ? (
        <>
          Payment for the&nbsp;<strong className="text-capitalize">{quoteName}</strong>&nbsp;quote
          is pending!
        </>
      ) : (
        <>
          Payment for the&nbsp;<strong className="text-capitalize">{name}</strong>&nbsp;is pending!
        </>
      );
    return (
      <span className="d-flex align-items-center">
        <div className="d-flex flex-wrap align-items-center">
          {isModifiedPlan ? (
            finalMsg
          ) : (
            <>
              {finalMsg} Please click&nbsp;
              <ActionLink
                title={'here'}
                onClick={() =>
                  setupIntentId
                    ? redirectToCheckoutPage(setupIntentId)
                    : handlePayment({
                        id,
                        name,
                        pending_pi_client_secret_key: s?.pending_pi_client_secret_key,
                      })
                }
                style={{ lineHeight: 1 }}
              />
              &nbsp;to continue.
              {setupIntentId ? (
                <>
                  {' '}
                  If you wish to cancel the pending payment, click&nbsp;
                  <ActionLink
                    title={'here.'}
                    onClick={() => handleCancelPayment({ id, payment: s, setupIntentId })}
                    style={{ lineHeight: 1 }}
                  />{' '}
                </>
              ) : null}
            </>
          )}
        </div>
      </span>
    );
  };

  useEffect(() => {
    const fetchMessages = async () => {
      const newMessages = await Promise.all(
        failedSubscriptions
          ?.reduce((a, c) => {
            if (
              c?.quote_details?.setupintent_id &&
              a?.find(
                (_item) => _item?.quote_details?.setupintent_id === c?.quote_details?.setupintent_id
              )
            )
              return a;
            return [...a, c];
          }, [])
          .map(async (a) => {
            const text = await getText(a);
            if (!text) return null;
            return (
              <MessageBar
                loading={checkIfLoading(a.id)}
                key={a.id}
                text={text}
                style={{
                  marginTop: '1rem',
                  marginBottom: 0,
                }}
              />
            );
          })
      );

      // Filter out null values and set the messages state
      setMessages(newMessages.filter(Boolean));
    };

    fetchMessages();
  }, [failedSubscriptions, loadingIds, plans]);

  if (failedSubscriptions.length === 0) return null;

  return <div className="mb-4 w-100">{messages}</div>;
};
